export default function PepiscoImage() {
  return (
    <img
      data-testid="logo"
      src={"https://www.pepsico.com/favicon.ico"}
      style={{ width: "32px", cursor: "pointer", height: "58x" }}
    />
  );
}
